import CryptoJS from 'crypto-js';

export default class EncryptionHelper {
  private readonly key;

  private readonly iv;

  constructor() {
    if (!process.env.REACT_APP_ENCRYPTION_KEY && !process.env.REACT_APP_ENCRYPTION_IV) {
      throw new Error('The encryption information was not defined');
    }
    
    this.key = CryptoJS.enc.Base64.parse(process.env.REACT_APP_ENCRYPTION_KEY as string);
    this.iv = CryptoJS.enc.Base64.parse(process.env.REACT_APP_ENCRYPTION_IV as string);
  }

  decryptData(encryptedText: string): any {
    const decrypted = CryptoJS.AES.decrypt(encryptedText, this.key, {
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    const jsonString = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(jsonString);
  }
}
